/* eslint-disable dot-notation */

/*eslint-env browser */
import * as React from 'react'
import cx from 'classnames'
import styles from '../../data.grid.styl'
import { ColumnProps } from '../../models/column.props.configuration'
import { unescape } from 'lodash'
import { useEffect } from 'react'

export interface EditableCellProps<T> {
  data: T
  column: ColumnProps<T>
  value: any
}

function EditableCell<T>(props: EditableCellProps<T>) {
  const { data, column, value } = props
  const editableCell = React.useRef<HTMLDivElement>(null)

  function keydownHandle(e: KeyboardEvent) {
    if (!e) {
      e = (window.event || {}) as KeyboardEvent
    }
    if (e.keyCode === 13) {
      e.target['blur']()
      e.preventDefault()
    }
  }

  useEffect(() => {
    editableCell?.current?.addEventListener('keydown', keydownHandle)

    return () => {
      editableCell?.current?.removeEventListener('keydown', keydownHandle)
    }
  }, [])

  function createMarkup(encodedHtml) {
    return {
      __html: unescape(encodedHtml)
    }
  }

  function onChanged(e: React.FocusEvent<HTMLDivElement>) {
    const { target = {} as EventTarget & HTMLDivElement } =
      e || ({} as React.FocusEvent<HTMLDivElement>)
    const { innerText } = target
    if (typeof column.onChanged === 'function' && innerText !== value) {
      column.onChanged(innerText, data, column, e)
    }
  }

  return (
    <div className={styles.editableCellWrapper}>
      <div
        role={`editable_cell`}
        ref={editableCell}
        className={styles.editableCell}
        contentEditable
        suppressContentEditableWarning
        onBlur={onChanged}
        dangerouslySetInnerHTML={createMarkup(value)}
      />
      <i className={cx(styles.iconEdit, 'material-icons')}>edit</i>
    </div>
  )
}

export default React.memo(EditableCell)
